export const optionsStatut = [
    { value: "Tous", label: "Tous" },
    { value: "Validé", label: "Validé" },
    { value: "Anomalie", label: "Anomalie" }
]